import axios from "axios";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + "/web-api/2.0",
  headers: {
    post: {
      "Bypass-Tunnel-Reminder": "a",
    },
    get: {
      "Bypass-Tunnel-Reminder": "a",
    },
  },
});

export default api;
